import { ContentDisplayStyle, useMapContext, ViewType } from './Map.tsx';
import cn from '../utils/cn.ts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faMagnifyingGlass,
  faTimes,
} from '@fortawesome/free-solid-svg-icons';
import { control } from 'leaflet';
import layers = control.layers;
import { useContext } from 'react';
import { LanguageContext } from '@/common/Language.tsx';

export default function PanelStoryNav({
  bottom,
  className,
}: {
  bottom?: boolean;
  className: string;
}) {
  const { t } = useContext(LanguageContext);
  const { view, storyNavigate, storyLeave } = useMapContext();

  if (!(view && view.type === ViewType.Story)) return <></>;

  return (
    <div
      className={cn(
        'flex',
        '-mx-[40px]',
        !bottom ? '-mt-[12px]' : '-mb-[12px]',
        'text-center',
        !bottom
          ? ['border-b-1', 'border-b-white']
          : ['border-t-1', 'border-t-gray-200'],
        className
      )}
    >
      <div
        className={cn(
          'flex-1',
          'cursor-pointer',
          'p-[12px]',
          !bottom
            ? ['border-b-1', 'border-b-gray-200']
            : ['border-t-1', 'border-t-white'],
          'border-r-1',
          'border-r-gray-200',
          'hover:bg-radial',
          'hover:from-gray-200',
          'hover:to-gray-100',
          'flex',
          'items-center',
          'justify-center'
        )}
        onClick={() => {
          storyNavigate(false);
        }}
      >
        <span>
          <FontAwesomeIcon icon={faChevronLeft} className={'mr-[6px]'} />
          &nbsp;{t('BACK', 'ZURÜCK')}&nbsp;(
          {((view.markerIndex - 1 + view.layer.layers.length) %
            view.layer.layers.length) +
            1}
          )
        </span>
      </div>
      <div
        className={cn(
          'flex-2',
          'cursor-pointer',
          'p-[12px]',
          'border-l-1',
          'border-l-white',
          !bottom
            ? ['border-b-1', 'border-b-gray-200']
            : ['border-t-1', 'border-t-white'],
          'border-r-1',
          'border-r-gray-300',
          'hover:bg-radial',
          'hover:from-gray-200',
          'hover:to-gray-100',
          'flex',
          'items-center',
          'justify-center',
          'relative'
        )}
        onClick={() => {
          storyLeave();
        }}
      >
        <FontAwesomeIcon
          icon={faTimes}
          className={cn('mr-[6px]', 'ml-[12px]')}
        />
        &nbsp;{t('EXIT', 'STORY')}&nbsp;{t('STORY', 'MODUS')}&nbsp;
        {t('MODE', 'VERLASSEN')}
        <div className={cn('absolute', 'bottom-[6px]', 'w-[60%]')}>
          <ProgressBar
            totalSteps={view.layer.layers.length}
            currentStep={view.markerIndex}
            className={'w-full'}
          />
        </div>
      </div>
      <div
        className={cn(
          'flex-1',
          'cursor-pointer',
          'p-[12px]',
          !bottom
            ? ['border-b-1', 'border-b-gray-200']
            : ['border-t-1', 'border-t-white'],
          'border-l-1',
          'border-l-white',
          'hover:bg-radial',
          'hover:from-gray-200',
          'hover:to-gray-100',
          'flex',
          'items-center',
          'justify-center'
        )}
        onClick={() => {
          storyNavigate(true);
        }}
      >
        ({((view.markerIndex + 1) % view.layer.layers.length) + 1}
        )&nbsp;{t('NEXT', 'WEITER')}&nbsp;
        <FontAwesomeIcon icon={faChevronRight} className={'ml-[6px]'} />
      </div>
    </div>
  );
}

function ProgressBar({
  currentStep,
  totalSteps,
  className,
}: {
  currentStep: number;
  totalSteps: number;
  className?: string;
}) {
  const percentage = Math.min(100, ((currentStep + 1) / totalSteps) * 100);

  return (
    <div className={cn(className)}>
      <div className="w-full h-[4px] bg-gray-300 rounded-full">
        <div
          className="h-full bg-blue-500 rounded-full transition-all duration-300"
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
}
